<script setup lang="ts">
const colorMode = useColorMode()

const color = computed<string>(() => (colorMode.value === 'dark' ? '#111827' : 'white'))

defineShortcuts({
  escape: {
    usingInput: true,
    handler: (event?: KeyboardEvent) => {
      if (document.activeElement instanceof HTMLElement) {
        document.activeElement.blur()
      }
      event?.preventDefault()
    }
  }
})

useHead({
  meta: [
    { charset: 'utf-8' },
    { name: 'viewport', content: 'width=device-width, initial-scale=1' },
    { key: 'theme-color', name: 'theme-color', content: color }
  ],
  link: [{ rel: 'icon', href: '/favicon.svg' }],
  htmlAttrs: {
    lang: 'en'
  }
})

const title: string = 'SRXplorer'
const description: string = 'SRXplorer is a tool to explore and interact with the SRX universe.'

useSeoMeta({
  title,
  description,
  ogTitle: title,
  ogDescription: description
  // ogImage: 'https://dashboard-template.nuxt.dev/social-card.png',
  // twitterImage: 'https://dashboard-template.nuxt.dev/social-card.png',
  // twitterCard: 'summary_large_image'
})
</script>

<template>
  <div>
    <NuxtLoadingIndicator />

    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>

    <UNotifications />
    <UModals />
  </div>
</template>
